module.exports = __webpack_public_path__ + "img/milk_starcadiamlk.96e41de.png";